import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import type { ComponentType, ReactNode } from 'react'
import About from './pages/About'
import Blog from './pages/thoughts'
import MorphingEffect from './pages/thoughts/morphing-effect'
import AIArchitecture from './pages/thoughts/ai-architecture'
import VisualDesign from './pages/thoughts/visual-design'
import CoreConcepts from './pages/thoughts/core-concepts'
import CreativeFreedom from './pages/thoughts/creative-freedom'
import MobileMocks from './pages/thoughts/mobile-mocks'
import MindSync from './pages/thoughts/mind-sync'
import EvolutionOfIdea from './pages/thoughts/evolution-of-idea'
import Ruler from './pages/thoughts/ruler'
import Chibatore from './pages/thoughts/chibatore'
import ThoughtChibatore2 from './pages/thoughts/chibatore-2'
import MySetup from './pages/thoughts/my-setup'
import Cards from './pages/thoughts/cards'
import ThoughtMicrocosm from './pages/thoughts/microcosm'
import Seo from './components/Seo'
import './styles/globals.css'

type BlogArticleRoute = {
  slug: string
  title: string
  Component: ComponentType
}

const blogArticleRoutes: BlogArticleRoute[] = [
  { slug: 'microcosm', title: 'Microcosm', Component: ThoughtMicrocosm },
  { slug: 'morphing-effect', title: 'Creating the Morphing Effect of the Luma Dream Machine Website', Component: MorphingEffect },
  { slug: 'ai-architecture', title: 'Simplicity of AI Agents Architecture', Component: AIArchitecture },
  { slug: 'visual-design', title: 'Visual Design Language and Personality', Component: VisualDesign },
  { slug: 'core-concepts', title: 'Understanding Core Concepts in Modern Web Graphics', Component: CoreConcepts },
  { slug: 'creative-freedom', title: 'Creative Freedom and Visual Language in Prototyping', Component: CreativeFreedom },
  { slug: 'mobile-mocks', title: 'Mobile Interface Mockups and Design Systems', Component: MobileMocks },
  { slug: 'mind-sync', title: 'Mind Sync: Exploring Neural Interface Design', Component: MindSync },
  { slug: 'evolution-of-idea', title: 'Evolution of Idea', Component: EvolutionOfIdea },
  { slug: 'ruler', title: 'Interactive Focus Ruler', Component: Ruler },
  { slug: 'chibatore', title: 'Chibatore: High Quality Human Movement System', Component: Chibatore },
  { slug: 'chibatore-2', title: 'Chibatore 2: Advanced Movement System', Component: ThoughtChibatore2 },
  { slug: 'my-setup', title: 'My Setup 2025', Component: MySetup },
  { slug: 'cards', title: 'Cards: A Visual Language System', Component: Cards }
]

const BLOG_DESCRIPTION = 'Research notes, product experiments, and long-form writing by Sergey Tsibel.'

const RedirectToHome = () => {
  const location = useLocation()
  return <Navigate to={`/${location.search}`} replace />
}

const RedirectThoughtsToBlog = () => {
  const location = useLocation()
  const blogPath = location.pathname.replace(/^\/thoughts(?=\/|$)/, '/blog')
  return <Navigate to={`${blogPath}${location.search}${location.hash}`} replace />
}

const BlogMeta = ({ title, path, children }: { title: string; path: string; children: ReactNode }) => (
  <>
    <Seo
      title={`${title} | Sergey Tsibel`}
      description={BLOG_DESCRIPTION}
      url={`https://tsibel.com${path}`}
      robots="noindex, nofollow"
      googleBot="noindex, nofollow"
      type={path === '/blog' ? 'website' : 'article'}
    />
    {children}
  </>
)

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<About />} />
        <Route
          path="/blog"
          element={
            <BlogMeta title="Blog" path="/blog">
              <Blog />
            </BlogMeta>
          }
        />
        {blogArticleRoutes.map(({ slug, title, Component }) => (
          <Route
            key={slug}
            path={`/blog/${slug}`}
            element={
              <BlogMeta title={title} path={`/blog/${slug}`}>
                <Component />
              </BlogMeta>
            }
          />
        ))}
        <Route path="/thoughts/*" element={<RedirectThoughtsToBlog />} />
        <Route path="*" element={<RedirectToHome />} />
      </Routes>
    </BrowserRouter>
  )
}
